import type { AuthStore } from './store/interfaces'

import { lsAccessToken, lsRefreshToken, lsExpiresAt } from './storage'

export const _hydrateFromStorage = (state: AuthStore): void => {
  state.accessToken = lsAccessToken.value || ''
  state.refreshToken = lsRefreshToken.value || ''
  state.expiresAt = lsExpiresAt.value || 0
}
